import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import bgImg from '../assets/images/bg-guide01.png';
import titleImg from '../assets/images/guide01-title.png';
import descImg from '../assets/images/guide01-desc.png';
import btnRegister from '../assets/images/btn-register.png';
import BluePopup from '../components/BluePopup';
import { withUrlValidation } from '../components/withUrlValidation';
import { useSessionNavigation } from '../hooks/useSessionNavigation';

const FadeInBackground = styled.div.withConfig({
  shouldForwardProp: (prop) => !['visible', 'isFadingOut'].includes(prop)
})<{ visible: number; isFadingOut: boolean }>`
  width: 100vw;
  height: 100dvh;
  min-height: 100dvh;
  background: url(${bgImg}) center/cover no-repeat;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  opacity: ${({ visible, isFadingOut }) => isFadingOut ? 0 : visible};
  transition: opacity 0.5s ease;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: black;
    opacity: ${({ visible }) => 1 - visible};
    transition: opacity 0.9s ease;
    z-index: -1;
  }
`;

const Title = styled.img.withConfig({
  shouldForwardProp: (prop) => !['visible', 'isFadingOut'].includes(prop)
})<{ visible: number; isFadingOut: boolean }>`
  width: 85vw;
  max-width: 90vw;
  margin-top: 5dvh;
  margin-bottom: 4dvh;
  opacity: ${({ visible, isFadingOut }) => isFadingOut ? 0 : visible};
  transition: opacity 0.9s ease;
`;

const Desc = styled.img.withConfig({
  shouldForwardProp: (prop) => !['visible', 'isFadingOut'].includes(prop)
})<{ visible: number; isFadingOut: boolean }>`
  width: 85vw;
  max-width: 600px;
  margin-top: 6dvh;
  margin-bottom: 5dvh;
  opacity: ${({ visible, isFadingOut }) => isFadingOut ? 0 : visible};
  transition: opacity 0.9s ease;
`;

const RegisterButton = styled.img.withConfig({
  shouldForwardProp: (prop) => !['visible', 'isFadingOut'].includes(prop)
})<{ visible: number; isFadingOut: boolean }>`
  width: 90vw;
  max-width: 90vw;
  position: absolute;
  left: 50%;
  bottom: 5vh;
  transform: translateX(-50%);
  cursor: pointer;
  opacity: ${({ visible, isFadingOut }) => isFadingOut ? 0 : visible};
  transition: opacity 0.9s ease;
`;



const Guide01Page = () => {
  const { navigateWithSession } = useSessionNavigation();
  const [bgVisible, setBgVisible] = useState(0);
  const [titleVisible, setTitleVisible] = useState(0);
  const [descVisible, setDescVisible] = useState(0);
  const [popupVisible, setPopupVisible] = useState(false);
  const [registerVisible, setRegisterVisible] = useState(0);
  const [isPopupClosing, setIsPopupClosing] = useState(false);
  const [isFadingOut, setIsFadingOut] = useState(false);

  useEffect(() => {
    
    const bgTimer = setTimeout(() => setBgVisible(1), 100);
    // 타이틀 이미지는 즉시 표시
    setTitleVisible(1);
    const descTimer = setTimeout(() => setDescVisible(1), 700);
    // BluePopup과 등록하기 버튼을 동시에 표시 (1500ms 후)
    const popupTimer = setTimeout(() => setPopupVisible(true), 1500);
    const registerTimer = setTimeout(() => setRegisterVisible(1), 1500);
    return () => {
      clearTimeout(bgTimer);
      clearTimeout(descTimer);
      clearTimeout(popupTimer);
      clearTimeout(registerTimer);
    };
  }, []);

  const handleRegisterClick = () => {
    // 팝업이 보이는 상태라면 팝업부터 닫기
    if (popupVisible) {
      setIsPopupClosing(true);
    } else {
      // 팝업이 없으면 바로 페이지 페이드아웃
      startPageTransition();
    }
  };

  const handlePopupClose = () => {
    // 팝업이 완전히 닫힌 후 페이지 페이드아웃 시작
    startPageTransition();
  };

  const startPageTransition = () => {
    setIsFadingOut(true);
    // 페이지 페이드아웃 후 정보등록 페이지로 이동 (세션 파라미터와 함께)
    setTimeout(() => {
      navigateWithSession('/register');
    }, 500);
  };

  return (
    <FadeInBackground visible={bgVisible} isFadingOut={isFadingOut}>
      <Title src={titleImg} alt="웹 콘텐츠 안내 페이지" visible={titleVisible} isFadingOut={isFadingOut} />
      <Desc src={descImg} alt="스트림 채널에 접속하신 것을 환영합니다. ..." visible={descVisible} isFadingOut={isFadingOut} />
      {popupVisible && (
        <BluePopup 
          isClosing={isPopupClosing}
          onClose={handlePopupClose}
        >
          <span style={{ fontSize: '1.6rem', display: 'block' }}>[화신 등록을</span>
            <div style={{height: '0.4rem'}} />
           <span style={{ fontSize: '1.6rem', display: 'block' }}>하시겠습니까?]</span>
        </BluePopup>
      )}
      <RegisterButton 
        src={btnRegister} 
        alt="등록하기" 
        visible={registerVisible} 
        isFadingOut={isFadingOut}
        onClick={handleRegisterClick}
      />
    </FadeInBackground>
  );
};

export default withUrlValidation(Guide01Page, {
  requireValidation: true, // URL 검증 필요
  showCountdown: true
}); 